<template>
  <div>
      <template v-if="retailerPayment === null || retailerPayment === true">
        <div v-show="retailerPayment === null && history === null"><preLoader></preLoader></div>
        <div v-show="retailerPayment != null && history != null">

        <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'retailer_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount"></virtualAccountComponent>
        <fincaComponent v-else-if="paymentEngine == 'FINCA' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount"></fincaComponent>
        <meezanComponent v-else-if="paymentEngine == 'MEEZAN' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount" :meezan_balance="meezan_balance"></meezanComponent>
        <nbpFundsComponent v-else-if="paymentEngine == 'NBP_FUND' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount" :numberOfBeneficiaries="users"></nbpFundsComponent>
        <easypaisaComponent v-else-if="paymentEngine == 'EASY_PAISA' " :paymentType="'vendor_payment'" :payroll_id="payroll_id"></easypaisaComponent>
        <faysalComponent v-else-if="paymentEngine == 'FAYSAL' " :paymentType="'vendor_payment'" :payroll_id="payroll_id"></faysalComponent>

    <div class="modal fade" id="addToArchiveDuplicatePopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body send-to-checker-popup text-center p-4">
                    <span class="exclamation-outer">
                        <i class="fas fa-exclamation"></i>
                    </span>
                    <h2 class="mt-4 mb-3"> Wait! Are you sure to move this batch to Archive and create a duplicate? </h2>
                    <button type="button" class="btn btn-primary addToArchiveDuplicate" @click="archiveAndDuplicate()">Yes</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                </div>
            </div>
        </div>
    </div>
    <!--Re upload Modal -->
    <div class="modal fade" id="reUploadBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body send-to-checker-popup text-center p-4">
                    <div class="form-group mb-3">
                        <textarea v-model="reupload_comment" placeholder="Why are you reuploading this batch?" class="form-control"></textarea>
                    </div>
                    <h2 class="mt-4 mb-3"> Do you really want to reupload?  </h2>
                    <button type="button" class="btn btn-primary delete" @click="reuploadBatch()" >Yes</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                </div>
            </div>
        </div>
    </div>
    <!--Disapprove Modal -->
    <div class="modal fade" id="disapproveBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body send-to-checker-popup text-center p-4">
                    <div class="form-group mb-3">
                        <textarea v-model="disapprove_comment" placeholder="Why are you disapproving this batch?" class="form-control"></textarea>
                    </div>

                    <h2 class="mt-4 mb-3"> Do you really want to disapprove?  </h2>
                    <button type="button" class="btn btn-primary delete"  @click="disapproveBatch()">Yes</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="addToArchivePopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
                <h2 class="mt-4 mb-3"> Wait! Are you sure to move this batch to Archive? </h2>
                <button type="button" class="btn btn-primary addToArchive" @click="addToArchive()">Yes</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="sendToCheckerPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body send-to-checker-popup text-center p-4">
                    <span class="exclamation-outer">
                        <i class="fas fa-exclamation"></i>
                    </span>
                    <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                    <button type="button" class="btn btn-primary sendtochecker" @click="sendtochecker()">Yes</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                </div>
            </div>
        </div>
    </div>
    <!--Reject Batch-->
    <div class="modal fade" id="rejectBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body send-to-checker-popup text-center p-4">

                    <div class="form-group mb-3">
                        <textarea v-model="reject_comment" placeholder="Why are you revising this batch?" class="form-control"></textarea>
                    </div>

                    <h2 class="mt-4 mb-3"> Do you really want to revise this batch?  </h2>
                    <button type="button" class="btn btn-primary delete" @click="rejectBatch">Yes</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="sendToApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
                <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                <button type="button" class="btn btn-primary sendtoapprover" @click="sendtoapprover()">Yes</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="sendToSecondApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
                <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                <button type="button" class="btn btn-primary sendtosecondapprover" @click="sendtosecondapprover()">Yes</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
        </div>
      </div>
    </div>
	<div class="clearfix">
		<div class="page-top dropdown mb-1 mb-3 clearfix">
			<h1 class="float-left"> {{payroll_name}} <span class="highlight-color"> ({{new Intl.NumberFormat().format(payroll_amount)}} PKR) </span> </h1>
            <template v-if="processRetailerPayment == true">
                <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-if="((this.payrollStatus !==7 && this.payrollStatus !== 8 && this.payrollStatus !== 10) &&  (this.is_deleted == null && this.current_batch_approver < 2 && ( (this.alreadyApproved == false && this.payrollStatus <= 3) || this.payableTxn > 0) && this.processRetailerPayment == true && this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.payroll_amount && users > 0))"> Process </button>
                
                <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-if="((this.payrollStatus !==7 && this.payrollStatus !== 8 && this.payrollStatus !== 10) && (this.is_deleted == null && this.current_batch_approver < 2 && ( (this.alreadyApproved == false && this.payrollStatus <= 3) || this.payableTxn > 0) && this.processRetailerPayment == true && this.$global.user_vr_corp == 'NO' && users > 0))"> Process </button>
                
                <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToSecondApproverPopup" v-else-if="(this.current_batch_approver > 1 && this.is_deleted == null && this.alreadyApproved == false  && this.processRetailerPayment == true && this.payrollStatus <= 3)"> Send to {{this.$global.nextApprover}} </button>
            </template>
            <template v-else-if="retailerPaymentSendToApprover == true">
                <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "sendToApproverPopup()" v-if="this.is_deleted == null && this.payrollStatus <= 2 && this.retailerPaymentSendToApprover == true  && this.alreadyChecked == false"> Send To <template v-if="this.$global.nextChecker == ''">Approver</template><template v-else>{{this.$global.nextChecker}}</template> </a>
            </template>
            <template v-else-if="retailerPaymentSendToChecker == true">
    			<a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "sendToCheckerPopup()" v-if="this.is_deleted == null && this.payrollStatus <= 1 && this.retailerPaymentSendToChecker == true && this.alreadyMade == false"> Send To <template v-if="this.$global.nextMaker == ''">Checker</template><template v-else>{{this.$global.nextMaker}}</template> </a>
            </template>
            <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "addToArchivePopup()" v-if="this.is_deleted == null && this.archiveRetailer && this.payrollStatus == 11"> Add To Archive </a>
            <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "addToArchiveDuplicatePopup()" v-if="this.is_deleted == null && this.archiveDuplicateRetailer == true && this.payrollStatus == 11"> Archive and Duplicate </a>
            <button class="btn btn-primary float-right mr-1" v-if="this.payrollStatus == 10 && paymentEngine == 'FINCA'" @click="batchStatus()" data-toggle="modal"> Batch Status </button>
            
            <button class="btn btn-primary float-right mr-1" v-if="this.payrollStatus == 7 && reUploadButton == true" data-toggle="dropdown" @click="reUploadPopup()"> Re-upload </button>
            <button class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && approverRejectButton == true && this.payrollStatus <= 3" data-toggle="tooltip" data-placement="bottom" title="The batch will be sent back to checker for correction" @click="rejectPopup()"> Revise Batch </button>
            <button class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && disapproveButton == true && this.payrollStatus <= 3" @click="disapprovePopup()" data-toggle="tooltip" data-placement="bottom" title="The batch will be cancelled completely"> Disapprove </button>
			<a href="javascript:void(0);" class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && this.deleteRetailerPayment && (this.payrollStatus <= 3 || this.payrollStatus == 7)" @click = "deletePayment()"> Delete Batch </a>
            <div class="head-date float-right mr-2"> {{payroll_date}} <i class="fas fa-calendar-alt"></i> </div>
		</div>
		<div class="batch-history mb-3 clearfix">
			<h2> <span class="text"> Batch History </span> </h2>
			<ul class="batch-status-list">
				<li class="status-list-item" v-for="histry in history" v-bind:value="histry.id" v-bind:key="histry.id">
                    <span class="status uploaded" v-if="histry.action == 'UPLOAD'"> Uploaded </span>
                    <span class="status flagged" v-if="histry.action == 'FLAGGED'"> Flagged
                             <!-- Show Flagged Comment -->
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img :src="`${$global.base_url}/images/flag.png`" alt="" /> </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image">
                                        <img v-if="histry.image == null" v-bind:src="`${$global.base_url}/avatar/${histry.image}`" class="user-image" alt="">
                                        <strong class="user-image" v-if="histry.image != null">{{histry.username.substr(0,1)}}</strong>
						    		 </span>
                                     <p class="">
						    			<span class="user-status user-name">{{histry.username}}</span>
						    			<span class="user-status date">{{histry.updated_at}}</span>
						    		 </p>
						    	    </div>
						    	    <div class="text">
						    		 <p> {{histry.comment}} </p>
						    	    </div>
						       </div>
						      </div>
				    </span>
                    <span class="status flagged" v-if="histry.action == 'UNDERREVIEW'"> Under Review </span>
                    <span class="status uploaded" v-if="histry.action == 'REUPLOAD'"> Re-upload
                             <!-- Show Reuploaded Comment -->
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img src="/images/flag.png" alt="" /> </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image"><img v-bind:src="'/avatar/'+histry.image" alt=""  class="user-image" /> </span>
						    		 <p class="">
						    			<span class="user-status user-name">{{histry.username}}</span>
						    			<span class="user-status date">{{histry.updated_at}}</span>
						    		 </p>
						    	    </div>
						    	    <div class="text">
						    		 <p> {{histry.comment}} </p>
						    	    </div>
						       </div>
						      </div>
                    </span>
                    <span class="status rejected" v-if="histry.action == 'DISAPPROVED'"> Disapproved
                             <!-- Show Disapprove Comment -->
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img :src="'/images/flag.png'" alt="" /> </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image"><img v-bind:src="'/avatar/'+histry.image" alt=""  class="user-image" /> </span>
						    		 <p class="">
						    			<span class="user-status user-name">{{histry.username}}</span>
						    			<span class="user-status date">{{histry.updated_at}}</span>
						    		 </p>
						    	    </div>
						    	    <div class="text">
						    		 <p> {{histry.comment}} </p>
						    	    </div>
						       </div>
						      </div>
					</span>
                    <span class="status checked" v-if="histry.action == 'CHECKED'"> Checked </span>
                    <span class="status completed" v-if="histry.action == 'APPROVED'"> Approved </span>
                    <span class="status archived" v-if="histry.action == 'ARCHIVED'"> Archived </span>
                </li>

			</ul>
        </div>
        <div class="reconciliation-main mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                <h2 class="mb-3"> Batch Summary </h2>
                <div class="reconciliation-inner">
                    <div class="row mt-4 align-items-center">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Payable Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ payableTxn }} </span> </div>
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payableTxnAmount | formatAmount }} </span> </div>
                    </div>                    
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Successfull Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ successTxn }} </span> </div>
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ successTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Unsuccessfull Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ failedTxn }} </span> </div>
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ failedTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Batch Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{recordsTotal}} </span> </div>
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payroll_amount | formatAmount }} </span> </div>
                    </div>
                    <div class="reconciliation-footer mt-4">
                        <div class="row mt-3 align-items-center mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true ">
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block"> Total Fee: </span>
                            </div>
                            <div class="col-md-7"> <span class="amount d-block"> Rs. {{ transationfeeSum | formatAmount}} </span> </div>
                        </div>
                    </div>
                </div>
            </div>
        <div class="batch-process-history mb-3">
            <div class="batch-process-outer" v-for="bh in history" :key="bh.id" v-show="bh.action != 'UNDERREVIEW'">
                <div class="batch-process-inner created-by"  v-if="bh.action == 'UPLOAD'">
                    <span class="action-by"> Created By </span>
                    <div class="process-content">

                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>

                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                            {{bh.designation}}
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner checked-by" v-if="bh.action == 'CHECKED'">
                    <span class="action-by"> Checked By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation}}
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner approved-by" v-if="bh.action == 'APPROVED'">
                    <span class="action-by"> Approved By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>

                    <div class="batch-process-inner disapprove-by" v-if="bh.action == 'DISAPPROVED'">
                    <span class="action-by"> Dispproved By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>

                <div class="batch-process-inner approved-by" v-if="bh.action == 'DELETED'">
                    <span class="action-by"> Deleted By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner flagged-by" v-if="bh.action == 'FLAGGED'">
                    <span class="action-by"> Revised By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner archived-by" v-if="bh.action == 'ARCHIVED'">
                    <span class="action-by"> Archived By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner paid-by" v-if="bh.action == 'PAID'">
                    <span class="action-by"> Paid By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
                <div class="batch-process-inner reuploaded-by" v-if="bh.action == 'REUPLOAD'">
                    <span class="action-by"> Reuploaded By </span>
                    <div class="process-content">
                        <div class="user">
                            <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div>
                        <p class="batch-process-text">
                            <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                        </p>
                    </div>
                    <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                </div>
            </div>
        </div>
        <div v-if="this.$global.user_vr_corp == 'YES' && (this.payrollStatus < 4 || this.payableTxn > 0) && this.payableTxnAmount > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
            <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.$global.user_vr_balance}}</p>
        </div>
        <div class="alert alert-warning" role="alert" v-if="account_msg !== ''">
            <p><b> Warning! </b>{{account_msg}}</p>
        </div>
		<div class="">
			<div class="table">
                <div class="alert alert-warning" role="alert" v-if="unRegisterWalletCount > 0">
                <p><b> Warning! </b> Un-registered record(s) found in the batch.</p>
                </div>
                <div class="alert alert-danger" role="alert" v-if="failedTransactions==true">
                    <p><b> Warning! </b> There are some failed transaction(s).</p>
                </div>
                <div class="btns-holder dropdown-btns clearfix mb-3" v-show="exportBatch">
                    <div class="w-15 mr-2 float-left">
                        <select class="selectpicker custom-select2" @change="batchExport($event)">
                            <option value="">Export Batch</option>
                            <option value="complete">Complete</option>
                            <option value="successfull" >Successfull</option>
                            <option value="failed" >Failed</option>
                        </select>
                    </div>
                    <div class="w-15 mr-2 float-left">
                        <select class="selectpicker custom-select2" @change="printBatch($event)">
                            <option value="">Print Batch</option>
                            <option value="complete">Complete</option>
                            <option value="successfull" >Successfull</option>
                            <option value="failed" >Failed</option>
                        </select>
                    </div>
                    <a class="btn btn-primary float-left ml-1" v-if="unRegisterWalletCount > 0" @click="unRegisterWalletExport" href="javascript:void(0)"> Un-registered Record[s] </a>
                    <a class="btn btn-primary float-left ml-1" v-if="failedTransactions == true" @click="failedTransactionsExport" href="javascript:void(0)"> Failed Transactions </a>
                    <div class="filters-col m-0 float-right">
                        <input type="text" id="customSearch" class="search form-control" placeholder="Search" name="search" v-model="search" v-on:keyup="searchFilter" />
                    </div>  
                </div>
				<table id="viewVendorPaymentTable" class="table" style="width:100%">
			        <thead>
			            <tr>
			            	<th>Name</th>
                            <th>Account Title</th>
			                <th>Category</th>
                            <th>Fee</th>
			                <th>Net Payable</th>
                            <th>Purpose of Payment</th>
                            <th v-show="flagTD == true" align="center">Flag</th>
                            <th v-show="payTD == true || payVisible == true">Pay</th>
                            <th v-show="statusTD == true">Status</th>
                            <th v-show="downloadTD == true">Download</th>
			            </tr>
			        </thead>
			    </table>
			</div>
		</div>
	</div>
    </div>
    </template>
    <template v-else-if="retailerPayment === false">
            <notAllowed></notAllowed>
    </template>
  </div>
</template>

<script>
    var myTable = null;
    import virtualAccountComponent from '../modals/virtualAccountComponent';
    import fincaComponent from '../modals/fincaComponent';
    import meezanComponent from '../modals/meezanComponent';
    import nbpFundsComponent from '../modals/nbpFundsComponent';
    import easypaisaComponent from '../modals/easypaisaComponent';
    import faysalComponent from '../modals/faysalComponent';
    export default {
        components: {
            virtualAccountComponent,
            fincaComponent,
            meezanComponent,
            nbpFundsComponent,
            easypaisaComponent,
            faysalComponent
        },
        data() {
            return {
                search: null,
                payrollId : this.$route.params.id,
                recordsTotal : '',
                meezan_balance : '',
                account_status: '',
                account_msg : '',
                data : null,
                users: null,
                unRegisterWalletCount: null,
                exportBatch: false,
                failedTransactions: false,
                payroll_name:null,
                payroll_amount:null,
                payroll_date:null,
                retailerPayment : null,
                viewretailerbatchstatus: null,
                archiveDuplicateRetailer: null,
                archiveRetailer: null,
                retailerPaymentSendToApprover: null,
                retailerPaymentSendToChecker: null,
                processRetailerPayment: null,
                addRetailerPayment: null,
                history:null,
                no_of_maker:null,
                no_of_checker:null,
                no_of_approver:null,
                current_batch_maker:null,
                approverRejectButton:false,
                reject_retailer_payment: null,
                batchId : null,
				disapprove_retailer_payment: null,
				retailer_hold_payment: null,
                current_batch_checker:null,
                current_batch_approver:null,
                approve_history:null,
                alreadyMade:null,
                payrollStatus : '123',
                alreadyChecked:null,
                alreadyApproved:null,
                paymentEngine: '',
                canEdit : null,
                reUploadButton: false,
                disapproveButton: false,
                deleteRetailerPayment:false,
                flagTD: false,
                payTD: false,
                currentStatus:0,
                payVisible: false,
				statusTD: false,
                downloadTD: false,
                recordAction: '',
                disapprove_comment: '',
                is_deleted: '',
                payroll_id: this.$route.params.id,
                reject_comment: '',
                reupload_comment: '',
                flag_comment: '',
                row_id: 0,
                form: new Form({
                    username : '',
                    password : '',
                }),
                processForm : new Form({
                    customerName            : '',
                    iBAN                    : '',
                    balance                 : '',
                    Cookie                  : '',
                    paymentInstrumentBankAccountNumber  : '',
                    customerId              : '',
                    sessionId               : '',
                    paymentInstrumentIdSVA  : '',
                    payrollId               : this.$route.params.id,
                }),
                beforePayementBatchSummary:false,
                afterPayementBatchSummary:false,
                successTxn:null,
                successTxnAmount:null,
                failedTxn:null,
                failedTxnAmount:null,
                transationfeeSum:0,
                payableTxn: null,
                payableTxnAmount:0,
                mca:false,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('retailer_delete_batch|retailer_hold_payment|disapprove_retailer_payment|reject_retailer_payment|view_retailer_batch_status|archive_retailer_payment_create_new|archive_retailer_payment|retailer_payment_send_to_approver|retailer_payment_send_to_checker|process_retailer_payment|add_retailer_payment|retailer_payments').then(result => {

                this.deleteRetailerPayment = result.retailer_delete_batch;
                this.viewretailerbatchstatus = result.view_retailer_batch_status;
                this.archiveDuplicateRetailer = result.archive_retailer_payment_create_new;
                this.archiveRetailer = result.archive_retailer_payment;
                this.retailerPaymentSendToChecker = result.retailer_payment_send_to_checker;
                this.retailerPaymentSendToApprover = result.retailer_payment_send_to_approver;
                this.processRetailerPayment = result.process_retailer_payment;
                this.addRetailerPayment = result.add_retailer_payment;
                this.retailerPayment = result.retailer_payments;
                this.retailer_hold_payment = result.retailer_hold_payment;
                this.disapprove_retailer_payment = result.disapprove_retailer_payment;
                this.reject_retailer_payment = result.reject_retailer_payment;
            }).then(result => {
                if(this.retailerPayment == true){
                    $('.selectpicker').selectpicker('refresh');
                    this.getVendorPaymentList();
                    this.getPaymentEngineData();
                    if(this.reject_retailer_payment == true){
                        this.approverRejectButton=true;
                    }
                    if(this.disapprove_retailer_payment == true){
                        this.disapproveButton=true;
                    }
                }
                this.$Progress.finish();
            });
            var that = this;
            $(document).ready(function(){
                window.updateRecordAction = function(recordId,status){
                    that.updateRecordAction(recordId,status);
                }
            })
        },
        methods: {
            searchFilter(e){
                if (e.keyCode === 13) {
                    this.$Progress.start();
                    myTable.draw();  
                }
            },
            rejectPopup(){
                $('#rejectBatch').modal('show');
            },
            disapprovePopup(){
                $('#disapproveBatch').modal('show');
            },
            reUploadPopup(){
               $('#reUploadBatch').modal('show');
            },
            unRegisterWalletExport: function () {
                this.$Progress.start();
                axios.post('/api/unRegisterWalletExportVendor', {
                    id : this.payrollId,
                    batchId : this.batchId,
                },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'VendorBatchUnRegisteredWallet.csv')
                        document.body.appendChild(link)
                        link.click();
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            failedTransactionsExport: function () {
                this.$Progress.start();
                axios.post('/api/vendorFailedTransactionsExport', {
                    id : this.payrollId },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'VendorBatchFailed.csv')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                });
            },
            batchExport: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    this.$Progress.start();
                    axios.post('/api/vendorBatchExport', {
                        id : this.payrollId, batchType: param },{
                        responseType: 'blob'
                    }).then(res => {
                            if(res.status == 200){
                                    const url = URL.createObjectURL(new Blob([res.data], {
                                    type: 'application/vnd.ms-excel'
                                }))
                                const link = document.createElement('a')
                                link.href = url
                                link.setAttribute('download', 'VendorBatchList.csv')
                                document.body.appendChild(link)
                                link.click()
                                this.$Progress.finish();
                            }else{
                                this.$Progress.fail();
                            }
                        })
                        .catch(err => {
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        });
                }
            },
            printBatch: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    axios.post('/api/printVendorBatch/'+ this.$route.params.id, {
                        batchType: param })
                    .then((response) => {
                        if(response.status == 200){
                            var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                            mywindow.document.write(response.data);
                            mywindow.document.close(); // necessary for IE >= 10
                            mywindow.focus(); // necessary for IE >= 10*/
                            mywindow.print();
                            // mywindow.close();
                            return true;
                        }else{
                            this.showAlertBox('error','There is some problem');
                        }
                    }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    });
                }
            },
            batchStatus(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                axios.post('/api/batchStatusVendor',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
						this.$Progress.finish();
						if(res.data.code == 403){
							this.showToastBox('info',res.data.data);
						}else if(res.data.code == 200){
                            this.showToastBox('success',res.data.data);
                        }
                         this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            rejectBatch(){
                var payroll_id = this.payrollId;
                var comment = this.reject_comment;
                this.$Progress.start();
                $('#rejectBatch').modal('hide');
                axios.post('/api/rejectPayrollVendor',{
                    payroll_id: payroll_id,
                    comment: comment
                }).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Batch successfully revised');
                        this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            disapproveBatch(){
                var payroll_id = this.payrollId;
                var comment = this.disapprove_comment;
				this.$Progress.start();
                $('#disapproveBatch').modal('hide');
                axios.post('/api/disapproveBatchVendor',{
                    payroll_id: payroll_id,
                    comment:comment
				}).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Batch successfully disapproved'
                        });
                        this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
            reuploadBatch(){
				var payroll_id = this.payrollId;
				var reupload_comment = this.reupload_comment;
				this.$Progress.start();
                $('#reUploadBatch').modal('hide');
                axios.post('/api/reuploadBatchVendor',{
					payroll_id: payroll_id,
                    comment: reupload_comment
				}).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.$router.push('/vendorPaymentBulkUpload?payroll_id='+payroll_id);
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
            getPaymentEngineData: function(){
                this.$Progress.start();
                axios.post("/api/getPaymentEngine")
                    .then(res => {
                        if(res.status == 200){
                            this.paymentEngine = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            archiveAndDuplicate : function(){
                $('.addToArchiveDuplicate').prop('disabled',true);
                axios.get('/api/vendorPaymentArchiveAndDuplicate/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is Archived and created duplicate.');
                            this.getVendorPaymentData();
                            $('#addToArchiveDuplicatePopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            addToArchive : function(){
                $('.addToArchive').prop('disabled',true);
                axios.get('/api/vendorPaymentArchive/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is archived.');
                            this.getVendorPaymentData();
                            $('#addToArchivePopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            processVendorPayments: function(){
                this.$Progress.start();
                this.processForm.post('/api/VendorSendForPayment')
                    .then(res => {
                        if(res.status == 200){
                            $('#loginMoblizer').modal('hide');
                            $('#dt-new').DataTable().ajax.reload();
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            this.$router.push('/vendorPayment');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
            proceedPayroll: function(){
                if(this.form.username == '' || this.form.password == ''){
                    this.showToastBox('error','Please enter the credentials!');
                    return;
                }
                this.$Progress.start();
                this.form.post('/api/vendorCorpLogin')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if (res.data.status == '200'){
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                this.processForm.sessionId = res.data.data.sessionId;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showAlertBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            addToArchivePopup(){
                $('.addToArchive').prop('disabled',false);
                $('#addToArchivePopup').modal('show');
            },
            addToArchiveDuplicatePopup(){
                $('.addToArchiveDuplicate').prop('disabled',false);
                $('#addToArchiveDuplicatePopup').modal('show');
            },
            sendToCheckerPopup(){
                $('.sendtochecker').prop('disabled',false);
                $('#sendToCheckerPopup').modal('show');
            },
            sendToApproverPopup(){
                $('.sendtoapprover').prop('disabled',false);
                $('#sendToApproverPopup').modal('show');
            },
            sendToSecondApproverPopup(){
                $('.sendtoapprover').prop('disabled',false);
                $('#sendToSecondApproverPopup').modal('show');
            },
            viewVendorPaymentSheet: function(){
                var that = this;
                myTable = $('#viewVendorPaymentTable').DataTable({
                    searching:true,
                    processing: true,
                    serverSide: true,
                    sDom: '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "/api/viewVendorPaymentSheet/"+this.$route.params.id,
                        "headers": window.axios.defaults.headers.common,
                        "data": function (d) { d.search = that.search; },
                        "dataSrc": function ( response ) {
                            that.payroll_name = response.payrolllist.name;
                            that.is_deleted = response.payrolllist.deleted_at;
                            that.payrollStatus = response.payrolllist.status;
                            that.current_batch_maker = response.payrolllist.no_of_maker;
                            that.current_batch_checker = response.payrolllist.no_of_checker;
                            that.current_batch_approver = response.payrolllist.no_of_approver;
                            that.payroll_amount = response.payrolllist.payroll_amount;
                            that.batchId = response.batchId;
                            that.canEdit = response.payrolllist.canEdit;
                            that.approve_history = response.approve_history;
                            that.unRegisterWalletCount = response.unregisterWallet;
                            that.alreadyMade = response.alreadyMade;
                            that.alreadyChecked = response.alreadyChecked;
                            that.alreadyApproved = response.alreadyApproved;
                            that.no_of_maker = response.company.no_of_maker;
                            that.no_of_checker = response.company.no_of_checker;
                            that.no_of_approver = response.company.no_of_approver;

                            that.successTxn = response.successTxn;
                            that.successTxnAmount = response.successTxnAmount;
                            that.failedTxn = response.failedTxn;
                            that.failedTxnAmount = response.failedTxnAmount;
                            that.transationfeeSum = response.transationfeeSum;
                            that.payableTxn = response.payableTxn;
                            that.payableTxnAmount = response.payableTxnAmount;
                            that.recordsTotal = response.recordsTotal;

                            that.exportBatch = true;
                            if(response.payrolllist.payroll_frequency == 'ONETIME'){
                                that.payroll_date = response.payrolllist.from_date;
                            }else{
                                that.payroll_date = response.payrolllist.from_date+"-"+response.payrolllist.to_date;
                            }

                            if(response.payrolllist.status != 4 && response.payrolllist.status != 5){
                                if(that.addRetailerPayment == true){
                                    if(response.payrolllist.status == 7 || response.payrolllist.status == 6){
                                        that.flagTD = true;
                                    }
                                }
                                if(that.retailerPaymentSendToApprover || that.processRetailerPayment){
                                    that.flagTD = true;
                                }
                            }
                            if(that.retailer_hold_payment == true){
                                that.payTD = true;
                            }
                            if( that.addRetailerPayment == true && response.payrolllist.status == 7){ // flagged
                                that.reUploadButton = true;
                            }
                            if(response.payrolllist.status == 4 || response.payrolllist.status == 5){
                                that.statusTD = true;
                                that.downloadTD = true;
                            }

                            that.history = response.history;
                            that.users = response.records.length;
                            return response.records;
                        },
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name',
                        render: function(data,type,full){
                            if(full['payee_vendor_beneficiary'] !== null){
                                var title = '<div class="emp-detail-tooltip-'+full['id']+'">' +
                                    '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> Account Type : </span>' +
                                    '<span class="tooltip-col">'+full['payee_vendor_beneficiary']['account_type']+'</span>' +
                                    '</p>' +
                                    '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> Bank : </span>' +
                                    '<span class="tooltip-col">'+full['payee_vendor_beneficiary']['bank_name']+'</span>' +
                                    '</p>' +
                                    '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> Account Number : </span>' +
                                    '<span class="tooltip-col">'+full['payee_vendor_beneficiary']['account_number']+'</span>' +
                                    '</p>' +
                                    '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> CNIC/NTN : </span>' +
                                    '<span class="tooltip-col">'+that.vendorCnic(full['vendor'])+'</span>' +
                                    '</p>' +
                                    '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> Cell # : </span>' +
                                    '<span class="tooltip-col">'+full['mobileNo']+'</span>' +
                                    '</p>';
                                    if(full['vendor_info_others'] !== null){
                                        if(full['vendor_info_others']['outlet_code'] !== null){
                                            title += '<p class="custom-tooltip-content">' +
                                            '<span class="tooltip-col tooltip-title"> Outlet Code : </span>' +
                                            '<span class="tooltip-col">'+full['vendor_info_others']['outlet_code']+'</span>' +
                                            '</p>';
                                        }
                                        if(full['vendor_info_others']['region'] !== null){
                                            title += '<p class="custom-tooltip-content">' +
                                            '<span class="tooltip-col tooltip-title"> Region : </span>' +
                                            '<span class="tooltip-col">'+full['vendor_info_others']['region']+'</span>' +
                                            '</p>';
                                        }
                                        if(full['vendor_info_others']['area'] !== null){
                                            title += '<p class="custom-tooltip-content">' +
                                            '<span class="tooltip-col tooltip-title"> Area : </span>' +
                                            '<span class="tooltip-col">'+full['vendor_info_others']['area']+'</span>' +
                                            '</p>';
                                        }
                                        if(full['vendor_info_others']['channel'] !== null){
                                            title += '<p class="custom-tooltip-content">' +
                                            '<span class="tooltip-col tooltip-title"> Channel : </span>' +
                                            '<span class="tooltip-col">'+full['vendor_info_others']['channel']+'</span>' +
                                            '</p>';
                                        }
                                        if(full['vendor_info_others']['sub_channel'] !== null){
                                            title += '<p class="custom-tooltip-content">' +
                                            '<span class="tooltip-col tooltip-title"> Sub Channel : </span>' +
                                            '<span class="tooltip-col">'+full['vendor_info_others']['sub_channel']+'</span>' +
                                            '</p>';
                                        }
                                    }
                                title += '</div>';
                                }else{
                                    var title = '';
                                }
                            $(".vendor-detail-tooltip-"+full['id']).tooltip({
                                title:title,
                                html: true,
                                placement: 'right',
                                offset: '40',
                                template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                            });
                            return '<div class="vendor-detail-tooltip-'+full['id']+'" id="vendor-details-'+full['id']+'">'+full['name']+'</div>'
                        }},
                        {render: function(data,type,full){
                            if(full['payee_vendor_beneficiary'] !== null){
                                if(full['payee_vendor_beneficiary']['account_title'] == '' || full['payee_vendor_beneficiary']['account_title'] == null){
                                    return '---';
                                }else{
                                    return full['payee_vendor_beneficiary']['account_title'];
                                }
                            }else{
                                 return '---';
                            }
                        }},

                        {data: 'categoryname'},
                        {data: 'transactionfee',render: function(data,type,full){
                            if(full['transactionfee'] == '' || full['transactionfee'] == null){
                                return '---';
                            }else{
                                return parseFloat(full['transactionfee']) + parseFloat(full['transactionfed']);
                            }
                        }},
                        {data: 'net_salary'},
                        {data: 'reason'},
                        {render: function(data,type,full){
                            if(that.flagTD == true){
                                var html = full['comment_html'];
                                if(html !== undefined){
                                    html = html.split('"').join("\\'");
                                }
                                var userid = full["payee_id"];
                                var id = full["id"];
                                return '<span class="icon comment" onclick="VueComponents.viewVendorPaymentSheetComponent.methods.showCommentBox('+id+',\''+userid+'\');" data-toggle="popover-click'+id+'"> <i class="far fa-comment-alt"></i> </span>';
                            }else{
                                return '---';
                            }
                        },visible: that.flagTD},
                        {render: function(data,type,full){
                            var id = full["id"];
                            if(that.payTD == true && that.currentStatus !=10){
                                var action = full['action'];
                                if( (that.mca == true) || (full['transfered'] == null && action != 'REJECT')){
                                    if(action == 'PAY'){
                                        return '<select id="select'+id+'" onChange="window.updateRecordAction('+id+','+that.payrollStatus+')" class="form-control custom-select" name="action" id="">'+
                                        '<option value="PAY" selected>Pay</option>'+
                                        '<option value="HOLD">Hold</option>'+
                                        '<option value="REJECT">Reject</option>'+
                                        '</select>';
                                    }else if(action == 'HOLD'){
                                        return '<select id="select'+id+'" onChange="window.updateRecordAction('+id+','+that.payrollStatus+')" class="form-control custom-select" name="action" id="">'+
                                        '<option value="PAY">Pay</option>'+
                                        '<option value="HOLD" selected>Hold</option>'+
                                        '<option value="REJECT">Reject</option>'+
                                        '</select>';
                                    }else{
                                        return '<select id="select'+id+'" onChange="window.updateRecordAction('+id+','+that.payrollStatus+')" class="form-control custom-select" name="action" id="">'+
                                        '<option value="PAY">Pay</option>'+
                                        '<option value="HOLD">Hold</option>'+
                                        '<option value="REJECT" selected>Reject</option>'+
                                        '</select>';
                                    }
                                }else{
                                    return full['action'];
                                }
                            }else{
                                return full['action'];                   
                            }
                        },visible: that.payVisible},
                        {
                        render: function(data, type, full) {
                            if(that.statusTD == true && full['transfered'] == 1){
                                return (
                                '<i class="fas fa-smile" data-toggle="tooltip" data-placement="top" title="Paid" ></i>'
                            );
                            }else if(that.statusTD == true && full['transfered'] == 0){
                                return (
                                '<i class="fas fa-sad-tear" data-toggle="tooltip" data-placement="top" title="Failed"></i>'
                            );
                            }else{
                                return '---';
                            }
                            },visible: that.statusTD},
                        {render: function(data,type,full){
                            if(that.downloadTD == true && full['transfered'] == 1){
                                return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" onclick="VueComponents.viewVendorPaymentSheetComponent.methods.downloadSalarySlip('+full['id']+')" ><i class="fas fa-download"></i></a>';
                            }else{
                                return '---';
                            }
                        },visible: that.downloadTD},

                    ],
                    drawCallback: function(settings){
                         $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                });
            },
            showCommentBox: function(id,userid){
                let that = this;
                axios.post("/api/vendorBatchComment",{
                    id: id,
                }).then(res => {
                    if(res.status == 200){
                        if($("#commentData").length !=0){
                            $('#commentData').html(res.data.data);
                            $('#commentText').val('');
                        }

                        var flag_value = that.flag_comment;
                        var flagComment = '<div class="flag-comment-box clearfix">'+
                                    '<div id="commentData">' + res.data.data + '</div>' +
                            '<div class="main-textbox mb-3"><textarea class="form-control" id="commentText"></textarea></div>' +
                                    '<button class="btn btn-primary float-right" onclick="VueComponents.viewVendorPaymentSheetComponent.methods.addComment('+id+')"> Submit </button>' +
                            '</div>';
                        $('[data-toggle="popover-click'+id+'"]').popover({
                            html: true,
                            placement: 'right',
                            sanitize: false,
                            content: flagComment,
                            template: '<div class="popover flaged-comment" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
                        }).popover('show');

                        $(document).on( 'keyup', '#commentText',function () {
                            that.flag_comment = this.value;
                        });
                        $(document).mouseup(function(e)
                        {
                            var container = $('.popover');
                            if (!container.is(e.target) && container.has(e.target).length === 0)
                            {
                                $('.comment').popover('dispose');
                            }
                        });
                    }else{
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    }
                }).catch(err => {
                    //that.$Progress.fail();
                    that.showAlertBox('error','Error to load form data');
                });
            },
            vendorCnic(vendor){
                if(vendor !== null){
                    return vendor['cnic'];
                }else{
                    return '---';
                }
            },
           
            downloadSalarySlip: function(id){
                axios.get('/api/downloadVendorPaymentSlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200 || response.status == 204){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Payment Slip.pdf'
                        link.click();
                        this.showToastBox('success','File downloaded successfully');
                    }else{
                        this.showAlertBox('error','Something went wrong, Please try again');
                    }

                });
            },
            updateRecordAction(recordId,status){
                var that = this;
                var obj = {
                    action: $("#select"+recordId).find("option:selected").val(),
                    sheetStatus: status,
                    recordId: recordId,
                    payrollId : that.payrollId
                }
                that.$Progress.start();
                axios.post("/api/updateRecordActionVendor", obj)
                    .then(res => {
                        if(res.status == 200){
                            that.payableTxn = res.data.data.totalPayableCount;
                            that.payableTxnAmount = res.data.data.totalPayableAmount;
                            that.$Progress.finish();
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        that.showAlertBox('error','Error to load form data');
                        that.$Progress.fail();
                    });
            },
            addComment: function(id){
                var that = this;
                var id = id;
                if(that.flag_comment == ''){
                    return false;
                }
                //that.$Progress.start();
                axios.post("/api/addVendorBatchComment",{
                    id: id,
                    flag_comment: that.flag_comment,
                })
                    .then(res => {
                        if(res.status == 200){
                            //that.$Progress.finish();
                            $('#commentData').html(res.data.data);
                            $('#commentText').val('');
                            that.flag_comment = '';
                            //this.getUserData(id);
                            /*$('[data-toggle="popover"]').popover();*/
                        }else{
                            //that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    });
            },

            getVendorPaymentData(){
                axios.get('/api/vendorPaymentData/'+this.$route.params.id, {
                })
                    .then(res => {

                        if(res.status == 200){
                            this.payroll_name = res.data.payrolllist.name;
                            this.payrollStatus = res.data.payrolllist.status;
                            this.current_batch_maker = res.data.payrolllist.no_of_maker;
                            this.current_batch_checker = res.data.payrolllist.no_of_checker;
                            this.current_batch_approver = res.data.payrolllist.no_of_approver;
                            this.payroll_amount = res.data.payrolllist.payroll_amount;
                            this.canEdit = res.data.payrolllist.canEdit;
                            this.approve_history = res.data.approve_history;
                            this.alreadyMade = res.data.alreadyMade;
                            this.alreadyChecked = res.data.alreadyChecked;
                            this.alreadyApproved = res.data.alreadyApproved;
                            this.no_of_maker = res.data.company.no_of_maker;
                            this.no_of_checker = res.data.company.no_of_checker;
                            this.no_of_approver = res.data.company.no_of_approver;
                            if(res.data.payrolllist.payroll_frequency == 'ONETIME'){
                                this.payroll_date = res.data.payrolllist.from_date;
                            }else{
                                this.payroll_date = res.data.payrolllist.from_date+"-"+res.data.payrolllist.to_date;
                            }
                            this.history = res.data.history;
                        }
                            //this.viewVendorPaymentSheet();
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load data'
                        });
                    });
            },
            getVendorPaymentList(){
                var that = this;
                axios.get('/api/vendorPaymentList/'+this.$route.params.id, {
                })
                    .then(response => {
                        if(response.status == 200){

                            response = response.data;
                            this.meezan_balance = response.meezan_balance;
                            this.account_status = response.account_status;
                            if(this.account_status !== '' || this.account_status !== null){
                                if(this.account_status.status == 400){
                                    this.account_msg = this.account_status.msg;
                                }
                            }
                            if(response.payrolllist == null){
                                this.vendorPayment = false;
                            }else{
                                var status = response.payrolllist.status;
                                that.currentStatus = status;

                                if(status == 1 || status == 2 || status == 3 || status == 7 || status == 8){
                                    this.beforePayementBatchSummary = true;
                                }
                                if(status == 4 || status == 5 || status == 11){
                                    this.afterPayementBatchSummary = true;
                                }
                                if(response.payrolllist.status != 4 && response.payrolllist.status != 5){
                                    if(that.addRetailerPayment == true){
                                        if(response.payrolllist.status == 7 || response.payrolllist.status == 6){
                                            that.flagTD = true;
                                        }
                                    }
                                    if(that.retailerPaymentSendToApprover || that.processRetailerPayment){
                                        that.flagTD = true;
                                    }
                                }
                                if(this.retailer_hold_payment && status !=10){
                                    this.payTD = true;
                                    that.payVisible = true;
                                }else{
                                    this.payTD = true;
                                    that.payVisible = true;
                                }
                            if(status == 1 || status == 2 || status == 3 ){
                                that.mca = true;
                            }
                                    
                            // if((that.processRetailerPayment && response.payrolllist.status <= 3) || (that.processRetailerPayment && response.payrolllist.status === 4 && response.holdCount > 0)){
                            //     that.payTD = true;
                            // }
                            if(response.payrolllist.status == 4 || response.payrolllist.status == 5){
                                that.statusTD = true;
                                that.downloadTD = true;
                            }
                            that.viewVendorPaymentSheet();
                        }
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            sendtochecker : function(){
                $('.sendtochecker').prop('disabled',true);
                    axios.get('/api/vendorPaymentSendToChecker/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            if(this.$global.nextMaker == ''){
                                this.showToastBox('success','You batch is sent to checker successfully');
                            }else{
                                this.showToastBox('success','You batch is sent to '+this.$global.nextmaker+' successfully');
                            }
                            this.getVendorPaymentData();
                            $('#sendToCheckerPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            deletePayment(){

                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    this.$Progress.start();
                    if (result.value) {
                        axios.get('/api/deleteVendorPayment/'+this.$route.params.id, {})
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.code == 200){
                                    this.showToastBox('success','Your batch is deleted successfully');
                                    this.$router.push('/vendorPayment');
                                }else{
                                    this.showAlertBox('error','Error in deleteing your batch.');
                                }
                            }else{
                                this.showAlertBox('error','Error in deleting your batch');
                            }
                        })
                        .catch(err => {
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.$Progress.fail();
                        this.showAlertBox('error','Your decision has been cancelled');
                    }
                })
            },
            sendtoapprover(){
                $('.sendtoapprover').prop('disabled',true);
                axios.get('/api/vendorPaymentSendToApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            if(this.$global.nextChecker == ''){
                                this.showToastBox('success','Your batch is sent to approver successfully');
                            }else{
                                this.showToastBox('success','Your batch is sent to '+this.$global.nextChecker+' successfully');
                            }
                            this.getVendorPaymentData();
                            $('#sendToApproverPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            sendtosecondapprover(){
                $('.sendtosecondapprover').prop('disabled',true);
                axios.get('/api/vendorPaymentSendToSecondApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is approved successfully');
                            this.getVendorPaymentData();
                            $('#sendToSecondApproverPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            /*sendtoapprovery : function(){
               const swalWithBootstrapButtons = Swal.mixin({})
                swalWithBootstrapButtons.fire({
                title: 'Are you sure?',
                text: "Double checks are always great! Do you want to check again or proceed?",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: "No, cancel it!",
                confirmButtonText: "Yes, Send it!",
                reverseButtons: true
                }).then((result) => {
                if (result.value) {
                    this.sentToApproverAction();
                } else if (
                    /!* Read more about handling dismissals below *!/
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    swalWithBootstrapButtons.fire(
                    'Cancelled',
                    'You cancel the Batch for re-verification',
                    'error'
                    )
                }
                })
            },
            sentToApproverAction(){
                axios.post('/api/sendForApprover/',{payrollId : this.payrollId})
                .then(res => {
                    if(res.status == 200){
                        toast.fire({
                                type: 'success',
                                title: 'Your Batch sent to Approver successfully.',
                                });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },*/
            ProceedPayment : function(){

            }
        },
        created() {
        }
    }
</script>
